import React, { useEffect, useState } from "react";
import ProductCard from "./ProductCard";
import { useParams } from "react-router-dom";
import CatNav from "./CatNav";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
  getAllProducts,
  getWishList,
} from "../../redux/features/product/productSlice";
import Spinner from "../Spinner";
// Pagination
import ResponsivePagination from "react-responsive-pagination";
import "react-responsive-pagination/themes/classic.css";

const AllProducts = () => {
  const dispatch = useDispatch();

  const [priceFilter, setPriceFilter] = useState("");

  const handlePriceFilterChange = (event) => {
    setPriceFilter(event.target.value);
  };

  const params = useParams();

  // const [sort, setSort] = useState({ sort: "price", order: "desc" });
  // const [filterCategory, setFilterCategory] = useState([]);
  // const [page, setPage] = useState(1);
  // const [search, setSearch] = useState(`${""}`);
  // console.log(search);
  const { products, isLoading, currentPag, totalPages, error } = useSelector(
    (state) => state.products
  );

  const { search, filterCategory, sort } = useSelector((state) => state.search);

  const [currentPage, setCurrentPage] = useState(currentPag);

  useEffect(() => {
    if (error) {
      toast.error(error);
    }

    dispatch(getAllProducts({ sort, filterCategory, currentPage, search }));
    dispatch(getWishList());
  }, [sort, filterCategory, currentPage, params]);

  return (
    <div className="bg-slate-100">
      {isLoading ? <Spinner /> : ""}
      <div className="px-[10px] md:px-[20px] lg:px-[3%] min-h-[30vh] pb-10">
        <CatNav />

        {products ? (
          <div className=" flex flex-row ">
            {/* filter */}
            <div className=" flex flex-1 flex-col pt-16 ">
              {/* Filter by Rating */}
              {/* <div className="bg-white p-6 rounded-lg shadow-md">
                <h1 className="text-lg font-semibold mb-4">Filter by price</h1>
                <div>
                  <label className="inline-flex items-center mr-4">
                    <input
                      type="radio"
                      value="highToLow"
                      checked={priceFilter === "highToLow"}
                      onChange={handlePriceFilterChange}
                      className="form-radio text-blue-500"
                    />
                    <span className="ml-2">High to Low</span>
                  </label>

                  <label className="inline-flex items-center">
                    <input
                      type="radio"
                      value="lowToHigh"
                      checked={priceFilter === "lowToHigh"}
                      onChange={handlePriceFilterChange}
                      className="form-radio text-blue-500"
                    />
                    <span className="ml-2">Low to High</span>
                  </label>
                </div>
              </div> */}

              {/* Filter by ratings */}
              {/* <div className="bg-white p-6 rounded-lg shadow-md mt-5">
                <h1 className="text-lg font-semibold mb-4">Filter by Rating</h1>
                <div>
                  <label className="inline-flex items-center mr-4">
                    <input
                      type="radio"
                      value="highToLow"
                      checked={filter === "highToLow"}
                      onChange={handleFilterChange}
                      className="form-radio text-blue-500"
                    />
                    <span className="ml-2">Top Rated to Low Rated</span>
                  </label>

                  <label className="inline-flex items-center">
                    <input
                      type="radio"
                      value="lowToHigh"
                      checked={filter === "lowToHigh"}
                      onChange={handleFilterChange}
                      className="form-radio text-blue-500"
                    />
                    <span className="ml-2">Low Rated to Top Rated</span>
                  </label>
                </div>
              </div> */}
            </div>
            <div className=" min-h-[30vh] lg:w-[75vw] pb-16 grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 justify-center    pt-10">
              {products.map((p) => (
                <ProductCard
                  key={p._id}
                  name={p.name}
                  image={p.images[0]?.url}
                  price={p.price}
                  id={p._id}
                  description={p.description}
                  ratings={p.ratings}
                  numOfReviews={p.numOfReviews}
                />
              ))}
            </div>
          </div>
        ) : (
          <h1 className=" mt-[50%] text-black text-center">
            Product Not Found!
          </h1>
        )}

        <ResponsivePagination
          current={currentPage}
          total={totalPages}
          onPageChange={setCurrentPage}
        />
      </div>
    </div>
  );
};

export default AllProducts;
